import { normalizeReferralCode } from "@/lib/referral";

/**
 * The partner code of a partner page (/p/lena, /en/p/lena …), or null. On such
 * a page the header, the dock and the WhatsApp links carry the code too, so a
 * couple who takes the header's "book" button still gets the €25 off and the
 * partner still gets the credit (12.10.2026). Read from the URL only, nothing
 * is stored on the device.
 */
const PARTNER_PATH = /^(?:\/(?:en|da|ar|uk|ru|vi|es))?\/p\/([^/?#]+)\/?$/i;

export function partnerCodeFromPath(pathname: string | null | undefined): string | null {
  const m = (pathname ?? "").match(PARTNER_PATH);
  if (!m) return null;
  try {
    return normalizeReferralCode(decodeURIComponent(m[1]));
  } catch {
    return null;
  }
}

/** Where the header's and dock's main buttons lead on a partner page. */
export function partnerHrefs(code: string | null) {
  return {
    check: code ? `/eignungs-check?code=${code}` : "/eignungs-check",
    book: code ? `/buchen?pkg=complete&code=${code}` : "/preise#pakete",
  };
}
